module.exports = __webpack_public_path__ + "img/104.913a1e03.png";